import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const CompanyForm = forwardRef(({company, onSaved, contact = null}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={company}
      type="company"
      fieldsComponent={Fields}
      onSave={(update) => services.company.saveCompany({...update, ...(contact ? {contact_id: contact.id} : {})})}
      onSaved={onSaved}
    />
  );
});

export default CompanyForm;
